import { render, staticRenderFns } from "./ChangePercent.vue?vue&type=template&id=0c79e24e&scoped=true"
import script from "./ChangePercent.vue?vue&type=script&lang=js"
export * from "./ChangePercent.vue?vue&type=script&lang=js"
import style0 from "./ChangePercent.vue?vue&type=style&index=0&id=0c79e24e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c79e24e",
  null
  
)

export default component.exports